import { Injectable } from '@angular/core';
import { BehaviorSubject, EMPTY } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { WebStorageService } from './webstorage.service';
import { AgentStatus } from '@app/_core/helper/AgentStatus';
import { DialerService } from '@app/_core/services/dialer.service';
import { TmQueueService } from '@app/_core/services/tm-queue.service';
const profileData: any = {
    AgentStatus: null,
    PhoneClient: null,
    PhoneNumber: null,
    QueueName: null,
    QueueStats: null,
    InteractionType: null,
    UseSoftPhone: false,
    NewVoicemails: 0,
    SoftPhoneStatus: 'Initializing...',
    Mode: null,
};
@Injectable({
    providedIn: 'root'
})
export class ProfileInfoService {
    private CurrentStatusId: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    private PrevStatusId: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    private AgentCurrentStatus: any;
    constructor(
        private webStorageService: WebStorageService,
        private agentStatus: AgentStatus,
        private dailerService: DialerService,
        private tmQueueService: TmQueueService,
    ) { }
    UpdateProfileStatus() {
        var phoneInfo = "No Phone Number";
        const user = this.webStorageService.getItemFromSessionStorage('currentUser');
        const loginParams = this.webStorageService.getItemFromSessionStorage('loginParams');
       
        if (user) {
            if (user.PhoneNumbers.length)
                profileData.PhoneNumber = user.PhoneNumbers[0].Number;
        }

        if (loginParams != null) profileData.UseSoftPhone = loginParams.UseSoftPhone;
        this.setCurrentStatusId(profileData.AgentStatus);
        phoneInfo = profileData.UseSoftPhone ? profileData.SoftPhoneStatus : ((profileData.PhoneNumber == null) ? phoneInfo : profileData.PhoneNumber);
        var currStatus = this.agentStatus.Statuses.Default;
        if (typeof profileData.AgentStatus == 'number') {
            currStatus = this.agentStatus.getStatusByID(profileData.AgentStatus);
        } else if (this.agentStatus.Statuses.hasOwnProperty(profileData.AgentStatus)) {
            currStatus = this.agentStatus.Statuses[profileData.AgentStatus];
        }
        this.AgentCurrentStatus = currStatus;
        //var externalSystemName = "";
        //if (currStatus == this.agentStatus.Statuses.ExternalSystem)
        //    currStatus.label = externalSystemName;
        //else if (currStatus == this.agentStatus.Statuses.ExternalAvailable)
        //    currStatus.label = externalSystemName + ' Available';
        //else
        if (profileData.InteractionType != null && profileData.InteractionType.indexOf('Chat') != -1) {
            switch (currStatus) {
                case this.agentStatus.Statuses.OnCall:
                    currStatus.label = 'On Chat';
                    break;
                case this.agentStatus.Statuses.PostCall:
                    currStatus.label = 'Post-Chat';
                    break;
                case this.agentStatus.Statuses.WaitingForCall:
                    currStatus.label = 'Waiting For Chat';
                    break;
            }
        }
       // console.log(currStatus.label + ' (' + phoneInfo + ')');        
        this.dailerService.setUserStatus(currStatus.label + ' (' + phoneInfo + ')');
    }

    setPhoneClient(client, useSoftPhone) {
        profileData.PhoneClient = client;
        profileData.UseSoftPhone = useSoftPhone;
        this.UpdateProfileStatus();
    }

    setQueueName(qName) {
        profileData.QueueName = qName;
        this.UpdateProfileStatus();
    }
    setAgentStatus(status) {
        profileData.AgentStatus = (status == null ? this.getPrevStatusId() : status);
        this.UpdateProfileStatus();
    }
    setSoftPhoneStatus(softPhoneStatus) {
        profileData.SoftPhoneStatus = (softPhoneStatus == null) ? "Initializing..." : softPhoneStatus;
        this.UpdateProfileStatus();
    }
    setUserStatus(statusID: any, queueID: any) {
        profileData.AgentStatus = (statusID == null ? this.getPrevStatusId() : statusID) ;
        this.UpdateProfileStatus();
        let qid=this.isEmptyOrWhitespace(queueID)?null:queueID;
        this.setUserStatusAPI(statusID, qid);
    }
    private setUserStatusAPI(statusID, queueID) {
        if (statusID != null) {
            this.tmQueueService
                .setUserStatus(statusID, queueID)
                .pipe(
                    map((data: any) => {
                        //console.log('setUserStatus response', data);
                    }),
                    catchError(error => {
                        console.log(error);
                        return EMPTY;
                    })
                ).subscribe();
        }
    }
    setInteractionType (type) {
        profileData.InteractionType = type;
        this.UpdateProfileStatus();
    }
    setCurrentStatusId(value: any) {
        this.PrevStatusId.next(this.CurrentStatusId.value);
        this.CurrentStatusId.next(value);
    }
    getPrevStatusId() { 
        return this.PrevStatusId.value;
    }

    getAgentStatus() {
        return profileData.AgentStatus;
        
    }
    getSoftPhoneStatus() {
        return profileData.SoftPhoneStatus;

    }

    getStatusLabel(){
        return this.AgentCurrentStatus;
    }
    isEmptyOrWhitespace(str) {
        return str === null || str === undefined || String(str || '').trim().length === 0;
      }
}
